
import { CSSProperties } from "@mui/material";

export const table_thead: CSSProperties = {
    backgroundColor: '#0A192D',
    color: '#ffffff',
    textAlign: 'left',
    fontSize: 38,
    fontWeight: 'lighter',
}

export const table_thead_pantalla: CSSProperties = {
    backgroundColor: '#1C395A',
    color: '#ffffff',
    textAlign: 'left',
    fontSize: 38,
    fontWeight: 'lighter',
    padding: '19px 15px',
}

export const table_thead_unidad: CSSProperties = {
    backgroundColor: '#1C395A',
    color: '#ffffff',
    textAlign: 'left',
    fontSize: 38,
    fontWeight: 'lighter',
    padding: '19px 15px',
}
export const table_cell_blue: CSSProperties = {
    color: '#ffffff',
    textAlign: 'center',
    borderRadius: 5, 
    border: '1px solid #b9dcff',
    backgroundColor: '#1B397D',
    background: 'linear-gradient(0deg,rgba(58, 94, 135, .8) 0%, rgba(35, 77, 123, .5) 50%)',
    boxShadow: '3px 4px 6px rgba(0, 0, 0, 0.4)',
    transparent:0.5,
}

export const table_cell_blue_light: CSSProperties = {
    backgroundColor: '#96AABE',
    color: '#ffffff',
    textAlign: 'center',
}
export const table_padding: CSSProperties = {
    padding: '3px 15px',
     borderBottom: '0px solid #98E3FC',
}
export const table_padding_pantalla: CSSProperties = {
    padding: '2px 15px',
    borderBottom: '0px solid #98E3FC',
}

export const table_tbody: CSSProperties = {
    backgroundColor: '#fff',
    borderBottom: '1px solid #1f6d88',
}
export const table_tbody_pantalla: CSSProperties ={
    backgroundColor:'#234d7b',
    borderBottom: '1px solid #1f6d88',
}

export const table_ubicacion: CSSProperties = {
    borderBottom: '1px solid #dddddd',
    backgroundColor: '#003366',
    color: '#ffffff',
}

export const content_table: CSSProperties = {
    border:'0px solid #1a1b1e', 
    borderRadius:2, 
    background: 'linear-gradient(140deg,rgba(59, 95, 135, 1) 0%, rgba(35, 77, 123, 1) 90%)',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.4)',
    margin:'30px 30px 0px 30px', 
    padding:'30px',
}

